// Where to go after signing in. `next` only ever holds a path on our own site, never a full URL,
// so a link like /sign-in?next=https://evil.example cannot send anyone away from the portal.

export const HOME = '/renewals/my';

const base = 'http://portal.invalid';

export function safeNext(raw: string | null | undefined): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return HOME;
  let url: URL;
  try {
    url = new URL(raw, base);
  } catch {
    return HOME;
  }
  if (url.origin !== base) return HOME;
  const path = url.pathname + url.search + url.hash;
  if (path === '/' || url.pathname === '/sign-in' || url.pathname.startsWith('/sign-in/')) {
    return HOME;
  }
  return path;
}

/** The Sign in address that returns to `from` afterwards. */
export function signInPath(from: string, expired = false): string {
  const params = new URLSearchParams();
  if (expired) params.set('expired', '1');
  const next = safeNext(from);
  if (next !== HOME) params.set('next', next);
  const query = params.toString();
  return query ? `/sign-in?${query}` : '/sign-in';
}

/** Keeps `next` on the way from Sign in to the code screen. */
export function withNext(path: string, next: string): string {
  return next === HOME ? path : `${path}?${new URLSearchParams({ next })}`;
}
